import { validate, submit } from '../../../assets/src/js/utils';

export default class ContactForm {
    constructor(rootNode) {
        this.$refs = {
            rootNode,
            form: rootNode.querySelector('form'),
            alert: rootNode.querySelector('.alert-anchor'),
            inputs: rootNode.querySelectorAll('input, textarea, select'),
            checkOnChange: false
        };

        this.$refs.rootNode.addEventListener('change', validate.bind(this))
        this.$refs.rootNode.addEventListener('submit', submit.bind(this))

        // Scroll to alert
        if(this.$refs.alert) {
            this.$refs.alert.scrollIntoView()
        }

        this.setupCaptchaListener();
    }

    setupCaptchaListener(){
        const button = this.$refs.rootNode.querySelector('button[type="submit"]');
        button.setAttribute('disabled', '');

        this.$refs.form.querySelector('altcha-widget').addEventListener('statechange', (e) => {
            const state = e.detail.state;

            if(state === 'verified'){
                button.removeAttribute('disabled');
            }else{
                button.setAttribute('disabled', '');
            }
        })
    }
};
